module.exports = __webpack_public_path__ + "img/lbfh.0ba24ac3.png";